module.exports = {"210212001":"登峰街道","210212002":"市场街道","210212003":"得胜街道","210212004":"光荣街道","210212005":"水师营街道","210212006":"龙王塘街道","210212007":"铁山街道","210212009":"双岛湾街道","210212010":"三涧堡街道","210212011":"长城街道","210212012":"龙头街道","210212013":"北海街道","210212400":"旅顺经济开发区","210212401":"大连奶牛场","210212402":"龙头分园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210212.json
// module id = 518
// module chunks = 0